import { render, staticRenderFns } from "./NewTransferReview.vue?vue&type=template&id=1c7f6855&scoped=true"
import script from "./NewTransferReview.vue?vue&type=script&lang=ts"
export * from "./NewTransferReview.vue?vue&type=script&lang=ts"
import style0 from "./NewTransferReview.vue?vue&type=style&index=0&id=1c7f6855&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f6855",
  null
  
)

export default component.exports